import { BORDER_COLOR } from './tableConstants';

export const calculateChildDepth = node => {
  if (!node?.child) return 0;
  return 1 + calculateChildDepth(node.child);
};

export const getColumnEntries = columns => Object.entries(columns ?? {});

export const resolveColumnValue = (row, key) => row?.[key];

export const parseQuestionDisplayName = name => {
  const raw = String(name ?? '').trim();
  const match = raw.match(/^(\d+(?:\.\d+)*\.?)\s*(.*)$/);

  if (!match) {
    return { questionNumber: '', questionName: raw };
  }

  return {
    questionNumber: (match[1] || '').replace(/\.$/, ''),
    questionName: (match[2] || '').trim()
  };
};

export const getColumnValues = (row, columnKeys) =>
  columnKeys.reduce((accumulator, column) => {
    accumulator[column] = row?.[column];
    return accumulator;
  }, {});

export const pickColumnValues = (row, columnKeys) => {
  if (!row) return {};

  return columnKeys.reduce((acc, column) => {
    acc[column] = row?.[column];
    return acc;
  }, {});
};

export const createBorderStyles = overrides => () => ({
  border: `1px solid ${BORDER_COLOR}`,
  borderTop: 'none',
  ...overrides
});

export const createCellBorderStyles = overrides => () => ({
  borderRight: `1px solid ${BORDER_COLOR}`,
  borderBottom: `1px solid ${BORDER_COLOR}`,
  ...overrides
});
